export default "__VITE_ASSET__fb1e04c6__"